import React from 'react';

import {withRouter, Redirect} from "react-router-dom";
import ErrorComponent from "./error";

const BACKEND_DOMAIN = document.location.hostname === 'localhost' ? 'http://localhost:5000' : ''

class Rollout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingData: true,
            redirectToListSites: false,
            errorOccurred: false
        }

        this.rolloutVariation = this.rolloutVariation.bind(this);
    }

    componentDidMount() {
        this.rolloutVariation()
    }

    rolloutVariation() {
        this.setState({
            loadingData: true
        })

        fetch(
            BACKEND_DOMAIN + `/api/rolloutVariation?siteId=${this.props.match.params.siteId}&variation=${this.props.match.params.variation}`,
            {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            }
        ).then(
            (result) => {
                if (result.ok) {
                    result.json().then(data => {
                        console.log(data)

                        this.setState({
                            loadingData: false,
                            redirectToListSites: true
                        })
                    })
                } else {
                    result.json().then(error => {

                        this.setErrorState(error)
                        this.setState({
                            loadingData: false,
                        })
                    })
                }
            }
        )
    }


    setErrorState(errorMessage) {
        const res = [...this.state.errorMessages || [], errorMessage]
        console.log(errorMessage, res, '!!')
        this.setState({errorMessages: res})
    }


    render () {
        if (this.state.errorMessages?.length) {
            return (<ErrorComponent errorMessages={this.state.errorMessages}></ErrorComponent>)
        } else if (this.state.loadingData) {
            return (
                <div style={{textAlign: "center"}}>
                    Loading. Please wait...
                </div>
            )
        } else if(this.state.redirectToListSites) {
            return (
                <Redirect
                    to={`/`}
                />
            )
        }
    }
}

export default withRouter(Rollout)
